// Shared authenticated fetch for the web app.
// Backend ke owner/cart/status/referral endpoints X-Auth-Token header maangte
// hain — isliye HAR call yahan se jaye (URL me token kabhi nahi).
const TOKEN_KEY = "authToken";

export const getAuthToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
};

export const getMobileFromStorage = () => {
  try {
    return localStorage.getItem("userMobileNumber") || "";
  } catch {
    return "";
  }
};

// fetch wrapper: X-Auth-Token (+ JSON content-type) inject karta hai.
// FormData body ho to Content-Type set nahi hoti (boundary khud aati hai).
export const authedFetch = async (url, options = {}) => {
  const headers = new Headers(options.headers || {});
  const isForm = typeof FormData !== "undefined" && options.body instanceof FormData;
  if (!isForm && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const token = getAuthToken();
  if (token) headers.set("X-Auth-Token", token);
  return fetch(url, { ...options, headers });
};